import type { PreloadedQuery } from 'react-relay';
import { getIssueKey } from '@jira/router-resources__utils/src/getIssueKey.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import type { consolidatedResourcesQuery as ConsolidatedResourcesQueryType } from './__generated__/consolidatedResourcesQuery.graphql.ts';
import getResourcesData from './getResourcesData.tsx';

export const issueViewResourcesDataResource: RouteResource<PreloadedQuery<
	ConsolidatedResourcesQueryType,
	{}
> | null> = createResource<PreloadedQuery<ConsolidatedResourcesQueryType, {}> | null>({
	type: 'ISSUE_VIEW_RESOURCES_DATA',
	getKey: ({ match }) => {
		const issueKey = getIssueKey(match);
		return issueKey || '';
	},
	getData: (...args) => getResourcesData(...args),
	isBrowserOnly: true,
});
